export class PaymentService {
  http;

  constructor(http) {
    this.http = http;
  }

  async getCardFee(amount, provider = 0) {
    return this.http.get('/payments/payment/card-fee', {
      params: {
        amount,
        provider
      }
    });
  }

  async exportPaymentSource(params) {
    params.renderMasthead = params.renderMasthead || false;

    return this.http.get('/payments/customer-source/export', {
      params
    });
  }

  async getFeeSchedule() {
    return this.http.get('/payments/payment/card-fee-schedule');
  }

  async createStripeCustomerSession(params) {
    return this.http.post('/payments/stripe-payment-intents/get-payment-info', params);
  }

  async checkStripeDuplicatePaymentMethod(customerId, confirmationToken) {
    return this.http.post('/payments/stripe-payment-intents/is-payment-method-unique', {
      customerId,
      confirmationToken
    });
  }

  async createPaymentIntents(paymentSourceId, amount, customerId, invoiceIds) {
    return this.http.post('/payments/stripe-payment-intents/create', {
      paymentSourceId,
      amount,
      customerId,
      invoiceIds
    });
  }

  async completeStripePaymentIntent(
    customerId,
    paymentSourceId,
    paymentIntentId,
    invoiceIds,
    amount,
    shouldSavePaymentSource,
    sourceType,
    cardType
  ) {
    return this.http.post('/payments/stripe-payment-intents/complete', {
      customerId,
      paymentSourceId,
      paymentIntentId,
      invoiceIds,
      amount,
      shouldSavePaymentSource,
      sourceType,
      cardType
    });
  }
}
